import { defineStore } from 'pinia'
import type { _AxiosError } from '@/stores/api'
import axios from '@/stores/api'
import type { AnonymousUser, UserPreference } from '@/types/anonymous-user.type'

interface State {
  current_user: AnonymousUser | null
}

export const useAuthStore = defineStore('authStore', {
  state: (): State => ({
    current_user: null,
  }),
  getters: {
    is_anonymous_loggedin(): boolean {
      return !!this.current_user
    },
    current_user_search_params(): UserPreference['searchParams'] {
      try {
        const pref = (this.current_user?.preference as unknown as string) ?? '{}'
        return JSON.parse(pref).searchParams || {}
      } catch {
        return {}
      }
    },
  },
  actions: {
    clear_current_user() {
      this.current_user = null
    },
    set_current_user(user: AnonymousUser) {
      this.current_user = user
    },
    signup_anonymous() {
      return new Promise<AnonymousUser>((resolve, reject) => {
        axios
          .post('/auth/anonymous/signup')
          .then((res) => {
            this.set_current_user(res.data)
            resolve(res.data)
          })
          .catch((err: _AxiosError) => {
            console.log(err)
            this.clear_current_user()
            reject(err)
          })
      })
    },
    authed_hello_anonymous() {
      return new Promise<AnonymousUser>((resolve, reject) => {
        axios
          .get('/auth/anonymous/hello')
          .then((res) => {
            this.set_current_user(res.data.anonymous_user)
            resolve(res.data)
          })
          .catch((err: _AxiosError) => {
            console.log(err)
            this.clear_current_user()
            reject(err)
          })
      })
    },
    login_anonymous() {
      return new Promise<AnonymousUser>((resolve, reject) => {
        axios
          .post('/auth/anonymous/login')
          .then((res) => {
            this.set_current_user(res.data)
            resolve(res.data)
          })
          .catch((err: _AxiosError) => {
            console.log(err)
            this.clear_current_user()
            reject(err)
          })
      })
    },
    update_preference_anonymous(preference: UserPreference) {
      axios
        .put('/users/me/preference', { preference: JSON.stringify(preference) })
        .then((res) => {
          this.set_current_user(res.data)
        })
        .catch((err: _AxiosError) => {
          console.log(err)
        })
    },
    refresh_anonymous() {
      return new Promise<void>((resolve, reject) => {
        axios
          .post('/auth/anonymous/refresh')
          .then((res) => {
            this.set_current_user(res.data)
            resolve()
          })
          .catch((err: _AxiosError) => {
            console.log(err)
            reject(err)
          })
      })
    },
    signout_anonymous() {
      return new Promise<void>((resolve, reject) => {
        axios
          .post('/auth/anonymous/signout')
          .then(() => {
            resolve()
          })
          .catch((err: _AxiosError) => {
            console.log(err)
            reject(err)
          })
      })
    },
  },
})
